// Photo filenames for Holiday Party 2019
const HOLIDAY_PARTY_2019 = [
  'xmass-2019-3_49420605403_l.jpg',
  'xmass-2019-4_49421070001_l.jpg',
  'xmass-2019-5_49420605478_l.jpg',
  'xmass-2019-8_49421292447_c.jpg',
  'xmass-2019-9-copy_49421225991_c.jpg',
  'xmass-2019-1_49421292427_l.jpg',
  'xmass-2019-2_49421292412_l.jpg',
];

export default HOLIDAY_PARTY_2019;
